/**
 * FE sentinel for the always-available "Other" choice, appended by each
 * surface to the end of the fetched provider list. An id only, never
 * rendered: the label is a locale-resolved react-intl message supplied
 * app-side. The value is the submit/persist contract with the backend; it
 * coincides with the legacy enum's `Other` member so pre-flag persisted
 * values still prefill, but it is deliberately NOT derived from
 * `EHRProvider`, which this migration retires.
 *
 * Declared in its own module, not in /contracts (a named string constant
 * there registers as a cache-key declaration to the key-single-site guard)
 * and not in `./api` (the EHR endpoint census reads every export of that
 * folder as an endpoint symbol).
 */
export const INTEGRATION_PROVIDER_OTHER_ID = 'Other';
